import FormQuestionType from '@/types/formQuestion'

export default class FormChapterType {
  public id!:number
  public name!:string
  public description!:string
  public number!:number
  public questions!:FormQuestionType[]
}
